export default __webpack_public_path__ + "static/hosting-static-main-6fb37aab973274f15c40a2e1c3182c9b.png";